module.exports = __webpack_public_path__ + "img/ci.3c8062d9.svg";